import React from "react";
import PropTypes from "prop-types";
import { AutocompleteField } from "../Formik";
import UserOption from "./UserOption";
import { hasElements } from "utils/arrays";

const UserSelect = ({ fieldName, disabled, multiple, limitTags, users, label, usersToExclude }) => {
    let userOptions = users;

    if (hasElements(usersToExclude)) {
        userOptions = (users || []).filter((x) => !usersToExclude.some((y) => y.id === x.id));
    }

    return (
        <AutocompleteField
            fieldName={fieldName}
            disabled={disabled}
            multiple={multiple}
            limitTags={limitTags}
            options={userOptions}
            label={label}
            valueKey="id"
            labelKey="name"
            variant="standard"
            renderOption={(user) => <UserOption {...user} />}
            getOptionLabel={(option) => (option ? option.name : "")}
        />
    );
};

UserSelect.propTypes = {
    fieldName: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    limitTags: PropTypes.number,
    users: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            email: PropTypes.string.isRequired,
            isAdmin: PropTypes.bool,
        })
    ),
    label: PropTypes.string,
    usersToExclude: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
        })
    ),
};

UserSelect.defaultProps = {
    disabled: false,
    multiple: false,
    users: [],
    limitTags: 2,
    label: "User",
    usersToExclude: [],
};

export default UserSelect;
